import React, {
  memo,
  useMemo,
} from 'react';

import {
  Tag,
  TagProps,
} from 'antd';

import { useTheme } from '../../context/ThemeProvider';

export interface ICustomTagProps extends TagProps {}

const CustomTag: React.FC<ICustomTagProps> = ({ color, style, ...props }) => {
  const { colors } = useTheme();

  const CONFIG: Record<
    string,
    { color: string; bgColor: string; borderColor: string }
  > = useMemo(() => {
    return {
      primary: {
        color: colors.WHITE,
        bgColor: colors.PRIMARY,
        borderColor: colors.PRIMARY,
      },
      secondary: {
        color: colors.WHITE,
        bgColor: colors.SECONDARY,
        borderColor: colors.SECONDARY,
      },
      info: {
        color: colors.WHITE,
        bgColor: colors.INFO,
        borderColor: colors.INFO,
      },
      'info-fill': {
        color: colors.INFO,
        bgColor: colors.INFO_FILL,
        borderColor: colors.INFO_FILL,
      },
      success: {
        color: colors.WHITE,
        bgColor: colors.SUCCESS,
        borderColor: colors.SUCCESS,
      },
      'success-fill': {
        color: colors.SUCCESS,
        bgColor: colors.SUCCESS_FILL,
        borderColor: colors.SUCCESS_FILL,
      },
      warning: {
        color: colors.WHITE,
        bgColor: colors.WARNING,
        borderColor: colors.WARNING,
      },
      'warning-fill': {
        color: colors.WARNING,
        bgColor: colors.WARNING_FILL,
        borderColor: colors.WARNING_FILL,
      },
      error: {
        color:  colors.WHITE,
        bgColor: colors.ERROR,
        borderColor: colors.ERROR,
      },
      'error-fill': {
        color: colors.ERROR,
        bgColor: colors.ERROR_FILL,
        borderColor: colors.ERROR_FILL,
      },
      purple: {
        color: colors.WHITE,
        bgColor: colors.PURPLE,
        borderColor: colors.PURPLE,
      },
      'purple-fill': {
        color: colors.PURPLE,
        bgColor: colors.PURPLE_FILL,
        borderColor: colors.PURPLE_FILL,
      },
    };
  }, [
    colors.ERROR, 
    colors.ERROR_FILL, 
    colors.INFO, 
    colors.INFO_FILL, 
    colors.PRIMARY, 
    colors.PURPLE, 
    colors.PURPLE_FILL, 
    colors.SECONDARY, 
    colors.SUCCESS, 
    colors.SUCCESS_FILL, 
    colors.WARNING, 
    colors.WARNING_FILL, 
    colors.WHITE
  ]);

  const { colorToUse, borderColor, backgroundColor } = useMemo(() => {
    if (!color || !CONFIG?.[color]) {
      return {};
    }

    return {
      colorToUse: CONFIG?.[color]?.color,
      borderColor: CONFIG?.[color]?.borderColor,
      backgroundColor: CONFIG?.[color]?.bgColor,
    };
  }, [CONFIG, color]);

  return (
    <Tag
      color={color}
      style={{
        color: colorToUse,
        backgroundColor,
        borderColor,
        ...style,
      }}
      {...props}
    />
  );
};

export default memo(CustomTag);
